import {
  Modal,
  ModalContent,
  type ModalHook,
  ModalSize,
  useControlledModalState,
} from '@leland-dev/leland-ui-library';
import { type FC } from 'react';

import MarkdownParser from '../common/MarkdownParser';

interface SessionDetailsModalHookProps {
  summary: string;
}
interface SessionDetailsModalProps extends SessionDetailsModalHookProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const SessionDetailsModalContent: FC<SessionDetailsModalProps> = ({
  open,
  setOpen,
  summary,
}) => {
  return (
    <Modal open={open} onOpenChange={setOpen}>
      <ModalContent size={ModalSize.SMALL} header="Session Summary">
        <div className="m-6">
          <MarkdownParser markdownText={summary} />
        </div>
      </ModalContent>
    </Modal>
  );
};

export const useSessionDetailsModal: ModalHook<
  SessionDetailsModalHookProps
> = () => {
  const [open, setOpen] = useControlledModalState();
  const SessionDetailsModal: FC<SessionDetailsModalHookProps> = (props) => {
    return (
      <SessionDetailsModalContent {...props} open={open} setOpen={setOpen} />
    );
  };
  return { open, setOpen, Modal: SessionDetailsModal };
};
